<div class="print-preview-bar">
  <div class="print-preview-bar__row">
    <button type="button" class="bpx-btn print-preview-bar__back" (click)="goBack()">
      <mat-icon fontIcon="arrow_back"></mat-icon>
      <span>Back{{ (backTo || viewName) ? ' to ' + (backTo || viewName) : '' }}</span>
    </button>

    <div class="print-preview-bar__heading">
      <span class="print-preview-bar__eyebrow">Print preview</span>
      <h1 class="print-preview-bar__title">{{ viewName || 'Print preview' }}</h1>
      @if (studyName || contextLine) {
        <span class="print-preview-bar__context">
          @if (studyName) { <strong>{{ studyName }}</strong> }
          @if (studyName && contextLine) { <span aria-hidden="true"> · </span> }
          {{ contextLine }}
        </span>
      }
    </div>

    <div class="print-preview-bar__actions">
      @if (hasColumns) {
        <button type="button" class="bpx-btn print-preview-bar__toggle" (click)="togglePanel()"
          [attr.aria-expanded]="panelOpen" aria-controls="print-preview-columns">
          <mat-icon [fontIcon]="panelOpen ? 'expand_less' : 'expand_more'"></mat-icon>
          <span>Columns</span>
          <span class="print-preview-bar__count">{{ selectedCount }} of {{ totalCount }}</span>
        </button>
      }
      <button type="button" class="bpx-btn bpx-btn--primary" (click)="print()" [disabled]="!canPrint"
        [title]="canPrint ? '' : 'Select at least one column to print'">
        <mat-icon fontIcon="print"></mat-icon>
        <span>Print</span>
      </button>
    </div>
  </div>

  @if (hasColumns && panelOpen) {
    <div class="print-preview-bar__panel" id="print-preview-columns">
      <div class="print-preview-bar__panel-head">
        <span class="bpx-control__label">Columns to include</span>
        <span class="print-preview-bar__panel-actions">
          <button type="button" class="bpx-btn" (click)="selectAll()"
            [disabled]="selectedCount === totalCount">Select All</button>
          <button type="button" class="bpx-btn" (click)="clearAll()"
            [disabled]="selectedCount === 0">Clear All</button>
        </span>
      </div>
      <div class="print-preview-bar__options" [class.print-preview-bar__options--scroll]="columnsScroll">
        @for (column of tableColumns; track trackByKey($index, column)) {
          <mat-checkbox class="print-preview-bar__option" [checked]="isChecked(column)"
            (change)="toggleColumn(column, $event.checked)">{{ label(column) }}</mat-checkbox>
        }
      </div>
      @if (!canPrint) {
        <p class="print-preview-bar__note">Nothing is selected, so the preview below is empty.</p>
      }
    </div>
  }
</div>
